// extracted by mini-css-extract-plugin
export var backButton = "styles-module--backButton--lr4y8";
export var icon = "styles-module--icon--PZ4tt";
export var messageContainer = "styles-module--messageContainer--9gHXy";
export var messageContent = "styles-module--messageContent--ucqcL";
export var userLabel = "styles-module--userLabel--f3Czm";